import React, { useContext } from 'react';
import { Formik, Form, Field, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { Button } from 'primereact/button';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { InputTextComponent, FormikCheckbox } from '../../components/prime-formik';
import { BEHAVIOR_SECTION } from './constants';
import DimensionBasicData from './DimensionBasicData';
import { AccountContext } from '../../components/AccountContext';

const i18nMessages = defineMessages({
  adjectivesLow: {
    id: 'menu.item-bank-management.adjectives-low',
    defaultMessage: 'Adjective - Low',
  },
  adjectivesHigh: {
    id: 'menu.item-bank-management.adjectives-high',
    defaultMessage: 'Adjective - High',
  },
  distortion: {
    id: 'menu.item-bank-management.distortion',
    defaultMessage: 'Distortion',
  },
});

const AddBehaviorDimension = () => {
  const currentAccount = useContext(AccountContext);
  const { formatMessage } = useIntl();
  const history = useHistory();
  const {
    setFieldValue,
    values: { dimension },
  } = useFormikContext();

  const dimensionValue = dimension.sectionCode === BEHAVIOR_SECTION ? dimension : null;

  const initialValues = {
    sectionCode: dimensionValue ? dimensionValue.sectionCode : BEHAVIOR_SECTION,
    code: dimensionValue ? dimensionValue.code : '',
    displayName: dimensionValue ? dimensionValue.displayName : '',
    description: dimensionValue ? dimensionValue.description : '',
    firstLowAdjective: dimensionValue ? dimensionValue.firstLowAdjective : '',
    secondLowAdjective: dimensionValue ? dimensionValue.secondLowAdjective : '',
    firstHighAdjective: dimensionValue ? dimensionValue.firstHighAdjective : '',
    secondHighAdjective: dimensionValue ? dimensionValue.secondHighAdjective : '',
    isDistortion: dimensionValue ? dimensionValue.isDistortion : false,
  };

  const validationSchema = Yup.object({
    code: Yup.string().required(),
    displayName: Yup.string().required(),
    description: Yup.string().required(),
    firstLowAdjective: Yup.string().required(),
    secondLowAdjective: Yup.string().required(),
    firstHighAdjective: Yup.string().required(),
    secondHighAdjective: Yup.string().required(),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, formikBag) => {
        formikBag.resetForm();

        setFieldValue('dimension', { ...values });

        history.push(`/accounts/${currentAccount}/add-itembank-assessment-content/add-behavior-items`);
      }}
      render={({ handleSubmit, setFieldValue: setInnerFormFieldValue }) => (
        <Form onSubmit={handleSubmit}>
          <Field type="hidden" value={BEHAVIOR_SECTION} name="sectionCode" />

          <DimensionBasicData />

          <div className="behavior-adjectives-input-container">
            <div className="input-label">{formatMessage(i18nMessages.adjectivesLow)}</div>
            <div className="behavior-adjectives-form-controls">
              <div>
                <Field id="firstLowAdjective" name="firstLowAdjective" component={InputTextComponent} />
              </div>
              <div>
                <Field id="secondLowAdjective" name="secondLowAdjective" component={InputTextComponent} />
              </div>
            </div>
          </div>

          <div className="behavior-adjectives-input-container">
            <div className="input-label">{formatMessage(i18nMessages.adjectivesHigh)}</div>
            <div className="behavior-adjectives-form-controls">
              <div>
                <Field id="firstHighAdjective" name="firstHighAdjective" component={InputTextComponent} />
              </div>
              <div>
                <Field id="secondHighAdjective" name="secondHighAdjective" component={InputTextComponent} />
              </div>
            </div>
          </div>

          <div className="behavior-distortion-controls">
            <strong className="input-label distortion">{formatMessage(i18nMessages.distortion)}</strong>
            <span>
              <Field
                id="isDistortion"
                name="isDistortion"
                setFieldValue={setInnerFormFieldValue}
                component={FormikCheckbox}
              />
            </span>
          </div>

          <div>
            <FormattedMessage id="actions.next" defaultMessage="Next">
              {(text) => <Button type="submit" label={text} />}
            </FormattedMessage>
            <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
              {(text) => (
                <Button
                  type="button"
                  onClick={() => history.push(`/accounts/${currentAccount}/dashboard`)}
                  className="p-button-secondary"
                  label={text}
                />
              )}
            </FormattedMessage>
          </div>
        </Form>
      )}
    />
  );
};

export default AddBehaviorDimension;
